
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 14 13.762\" id=\"icon-arrow-thin-left\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M6.602,0.113c0.15-0.149,0.401-0.151,0.548-0.002L8.33,1.288c0.155,0.16,0.143,0.393,0.005,0.551\r\n\tl-3.842,3.83l9.113,0.002c0.218-0.001,0.395,0.18,0.393,0.385L14,7.698c-0.001,0.212-0.179,0.389-0.395,0.391L4.492,8.087\r\n\tl3.84,3.832c0.141,0.154,0.153,0.398,0,0.55l-1.184,1.185c-0.143,0.149-0.396,0.145-0.545-0.006L0.147,7.184\r\n\tC0.036,7.071,0.001,7.006,0,6.878c0-0.12,0.036-0.196,0.146-0.309L6.602,0.113z\"/> </symbol>";
module.exports = sprite.add(image, "icon-arrow-thin-left");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/arrow-thin-left.svg
 ** module id = 144
 ** module chunks = 24
 **/